import api from './api'

export const payoutsService = {
  getAll: async (params = {}) => {
    const res = await api.get('/admin/payouts', { params })
    return res.data
  },

  approve: async (id, data) => {
    const res = await api.patch(`/admin/payouts/${id}/approve`, data)
    return res.data.data
  },

  getSummary: async () => {
    const res = await api.get('/admin/commissions/summary')
    return res.data.data
  },
}
